import leads from './user/leads/leads-modals';
import modalUser from './user/modals/modal-user';
import changePassword from './user/profile/change-password';
import editProfile from './user/profile/edit';
import managePage from './user/profile/manage';
import { initProfileOrganization } from './user/profile/organization/main';
import resettingPassword from './user/profile/resetting-password';

export default function () {
  managePage();
  editProfile();
  changePassword();
  resettingPassword();

  if (
    document.querySelector('header')
    && document.querySelector('.modal-user')
  ) {
    modalUser('.modal-user');
  }

  if (document.getElementById('lead-modals')) {
    leads();
  }

  if (document.getElementById('user-profile-team')) {
    initProfileOrganization();
  }
}
